import Entities from 'STORE';

import { Payload } from '../Payload';

export class SystemPayload extends Payload {
  initiator;
  initiatorNickName;
  contactId;
  users;
  groupName;
  systemMessagesEnabled;
  spaceName;
  periodMs;

  constructor(data) {
    super(data);

    this.initiator = data.initiator;
    this.initiatorNickName = data.initiatorNickName;
    this.contactId = data.contactId;
    this.users = data.users;
    this.groupName = data.groupName;
    this.oldName = data.oldName;
    this.newName = data.newName;
    this.newType = data.newType;
    this.systemMessagesEnabled = data.systemMessagesEnabled;
    this.spaceName = data.spaceName;
    this.periodMs = data.periodMs;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      initiator: this.initiator,
      initiatorNickName: this.initiatorNickName,
      contactId: this.contactId,
      users: this.users,
      groupName: this.groupName,
      oldName: this.oldName,
      newName: this.newName,
      newType: this.newType,
      systemMessagesEnabled: this.systemMessagesEnabled,
      spaceName: this.spaceName,
      periodMs: this.periodMs,
    };
  }

  get isSystem() {
    return true;
  }

  get canBeDelete() {
    return Entities.GroupsStore.getGroupById(this.message.groupId).withMeInAdmins;
  }
}
